import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DownloadIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M3 17.2941V19.6471C3 20.2711 3.2479 20.8696 3.68916 21.3108C4.13042 21.7521 4.7289 22 5.35294 22H19.4706C20.0946 22 20.6931 21.7521 21.1344 21.3108C21.5756 20.8696 21.8235 20.2711 21.8235 19.6471V17.2941M6.52941 7.88235L12.4118 13.7647M12.4118 13.7647L18.2941 7.88235M12.4118 13.7647V2"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

DownloadIcon.displayName = 'DownloadIcon';
